import {StyleSheet} from 'react-native';

import {
  cloudLight,
  cloudLighter,
  denim,
  onyx,
  white,
} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {padding: 0},
  cardContainer: {
    padding: 8,
    backgroundColor: white,
    marginHorizontal: 4,
    borderRadius: 12,
    margin: 16,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowOffset: {width: 0, height: 2},
    shadowRadius: 4,
    elevation: 3,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 10,
    padding: 12,
    borderRadius: 8,
    backgroundColor: 'white',
  },
  doneBackground: {
    backgroundColor: '#e0f7e9',
  },
  checkmark: {
    fontSize: 18,
    color: 'green',
    marginRight: 8,
  },
  labelContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  label: {
    flex: 1,
    flexWrap: 'wrap',
  },
  labelActive: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#000',
  },
  labelStrikethrough: {
    fontSize: 13,
    fontWeight: '900',
    textDecorationLine: 'line-through',
    color: '#888',
  },
  strikethrough: {
    textDecorationLine: 'line-through',
    color: '#666',
  },

  counterContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  counterBtn: {
    width: 40,
    height: 40,
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: '#ccc',
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  disabledBtn: {
    backgroundColor: '#E3E5E6',
  },
  disabledText: {
    color: '#8C919E',
    fontSize: 20,
    fontWeight: 'bold',
  },
  counterText: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  focusedBtn: {
    borderColor: 'blue',
    borderWidth: 4,
    borderRadius: 6,
  },
  input: {
    width: 50,
    height: 40,
    borderWidth: 1,
    borderColor: '#ccc',
    marginHorizontal: 8,
    textAlign: 'center',
    justifyContent: 'center',
    textAlignVertical: 'center',
    borderRadius: 8,
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  saveBtn: {
    marginTop: 24,
    backgroundColor: '#375019',
    padding: 16,
    borderRadius: 8,
    alignItems: 'center',
  },
  saveBtnText: {
    color: 'white',
    fontSize: 16,
    textAlign: 'center',
  },
  saveBtnDisable: {
    backgroundColor: '#A3B5A3',
  },
  selectedCheckbox: {
    borderRadius: 2,
    color: denim,
    backgroundColor: 'transparent',
  },
  infoIcon: {
    marginRight: 12,
    color: '#888',
    fontSize: 22,
  },
  unselectedCheckbox: {
    borderRadius: 2,
    color: white,
    backgroundColor: white,
    borderWidth: 2,
    borderColor: '#888',
    lineHeight: 24,
  },
  saveBtnOutside: {
    marginHorizontal: 24,
    marginTop: 8,
    marginBottom: 32,
    backgroundColor: '#375019',
    padding: 16,
    borderRadius: 8,
    alignItems: 'center',
  },
  completionContainer: {
    backgroundColor: '#DFF5DD',
    padding: 10,
    borderRadius: 8,
    alignItems: 'center',
    marginBottom: 10,
  },

  completionText: {
    color: '#2e7d32',
    fontWeight: 'bold',
    fontSize: 16,
  },
  modal: {
    backgroundColor: 'white',
    width: '100%',
    maxWidth: 400,
    margin: 0,
    padding: 20,
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    width: '100%',
    maxWidth: 450,
    backgroundColor: '#F8F8F8',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: 20,
    marginTop: 'auto',
  },
  webModalContainer: {
    margin: 0,
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  webModalView: {
    width: 420,
    height: '100%',
    backgroundColor: white,
    padding: 20,
  },
  webHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  iconContainer: {
    marginRight: 8,
    alignSelf: 'center',
    height: 30,
    width: 30,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: cloudLighter,
    cursor: 'pointer',
  },
  closeIcon: {
    fontSize: 18,
    color: onyx,
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: 10,
  },
  headerText: {
    fontSize: 16,
    marginLeft: 10,
  },
  base: {},
  header: {
    marginBottom: 10,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
  },
  body: {
    marginVertical: 20,
  },
  infoText: {
    fontSize: 15,
  },
});
